import React, { startTransition } from "react";
import { useSelector } from "react-redux";
import styles from "./dashBoardStyles.module.css";

const OrdersSection = () => {
  const data = useSelector((state) => state.dashboard.data);
  const ordersTableColumns = [
    { key: "ORDER NO", label: "orderNo" },
    { key: "STATUS", label: "status" },
    { key: "OPERATIORS", label: "operators" },
    { key: "LOCATION", label: "location" },
    { key: "DISTANCE", label: "distance" },
    { key: "START DATE", label: "startDate" },
    { key: "EST DELIVERY DUE", label: "deliveryDate" },
  ];
  return (
    <section className={styles.ordersTableSection}>
      <h1>Orders List</h1>
      <table className={styles.ordersTable} key="ordersTable">
        <thead>
          <tr className={styles.ordersHeadingTR}>
            {ordersTableColumns.map((columnName, index) => {
              return (
                <th key={`${columnName.key} ${index}`}>{columnName.key}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.orders.map((row, index) => {
            return (
              <tr key={`table row ${index}`} className={styles.ordersDataTR}>
                {ordersTableColumns.map((rowData, dataIndex) => {
                  return (
                    <td key={`${rowData.label} ${index}${dataIndex}`}>
                      {row[rowData.label]}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};

export default OrdersSection;
